/**
 * @author Кирилл Шабанов (@shabanov)
 */

import Vue from 'vue'
import i18next from 'i18next'
import { PiniaVuePlugin } from 'pinia'
import VueTheMask from 'vue-the-mask'
import I18NextVue from 'i18next-vue'
import getUserLanguage from 'src/utils/getUserLanguage'

Vue.config.devtools = process.env.NODE_ENV === 'development'

const userLanguage = getUserLanguage()

i18next.init({
  lng: userLanguage,
  resources: {},
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
})

Vue.use(I18NextVue, { i18next })
Vue.use(VueTheMask)
Vue.use(PiniaVuePlugin)

export default Vue
